// User-uploaded brand media.
// Videos are self-hosted, web-compressed copies in /public/videos/reels.
// Social posts live in /public/social (referenced by absolute path).


export const VIDEOS = {
  brand: '/videos/reels/leisure-wellness-naples-hot-tubs-saunas-cold-plunges.mp4',
  saunas: '/videos/reels/sauna-health-benefits-naples-fl.mp4',
  joeRoganSauna: '/videos/reels/joe-rogan-sauna-benefits.mp4',
  bearHotTub: '/videos/reels/hot-tub-stress-relief-transformation-naples-fl.mp4',
};

export const SOCIAL_POSTS = [
  { id: 'dog-hot-tub', src: '/social/dog-hot-tub.png', tag: 'Unwind', alt: 'Ruff day? A hot tub fixes that — Leisure Wellness Naples' },
  { id: 'penguin-cold-plunge', src: '/social/penguin-cold-plunge.png', tag: 'Cold Plunge', alt: 'Keep your cool — cold plunge benefits, Leisure Wellness Naples' },
  { id: 'camel-sauna', src: '/social/camel-sauna.png', tag: 'Sauna', alt: 'Sweat now, thank yourself later — sauna or hot tub' },
  { id: 'bear', src: '/social/bear.png', tag: 'Stress Relief', alt: 'Having a bear of a day? 20 minutes in a hot tub or sauna melts it away' },
  { id: 'monkey', src: '/social/monkey.png', tag: 'Tension Relief', alt: 'Get the monkey off your back — hot tub or sauna melts the knots away' },
  { id: 'lion-penguin-membership', src: '/social/lion-penguin-membership.png', tag: 'Memberships', alt: 'Sweat it out or cool it down — sauna + cold plunge memberships' },
  { id: 'seal', src: '/social/seal.png', tag: 'Recovery', alt: 'Seal the deal on recovery — hot tubs, saunas, cold plunges & swim spas' },
  { id: 'dolphin-pricing', src: '/social/dolphin-pricing.png', tag: 'Best Price', alt: "You'll flip for joy with our prices — factory-direct pricing" },
];
